
  <router-outlet #o="outlet"></router-outlet>

